<template>
  <div id="tools">
    <vue-loading :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>

    <nav class="navbar fixted-top navbar-light bg-light sub-nav">
      <div class="navbar-brand">Tools</div>
      <ul class="nav nav-pages mr-auto">
        <li class="nav-item" v-for="item in menu" :key="item.id">
          <a class="nav-link" :class="{'active': checkActive(item.id)}" type="button" @click="active=item">
            {{item.name}}
          </a>
        </li>
      </ul>
    </nav>

    <div v-if="!loading" class="container-fluid">
      <div v-if="active.id === 'summary'">
        <div class="row align-items-start" style="margin-bottom: 25px;">
          <div class="col-6">
            <div class="card">
              <div class="card-heading">
                Tool Migration Progress
              </div>
              <div class="card-body">
                <ToolsMigrated :toolsReport="tools"/>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-heading">
                Outdated Tool Versions
              </div>
              <div class="card-body">
                <ToolsOutdatedVersion
                  :toolsOutdated="summary.outdated_versions"
                  :accounts="summary.accounts"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-start" style="margin-bottom: 25px;">
          <div class="col-8">
            <div class="card">
              <div class="card-heading">
                Bearse Features
              </div>
              <div class="card-body">
                <ToolsBearseFeatures
                  :deployedFeatures="summary.bearse_features"
                  :accounts="summary.accounts"
                  :features="bearseFeatures"
                />
              </div>
            </div>
          </div>

          <div class="col-2">
            <div class="card">
              <div class="card-heading">
                <div>Accounts Reporting ({{len(summary.reported_accounts)}} out of {{len(summary.accounts)}} accounts)</div>
              </div>
              <div class="card-body">
                <PercentageOfAccounts :reported="len(summary.reported_accounts)" :total="len(summary.accounts)"/>
              </div>
            </div>
          </div>

          <div class="col-2">
            <div class="card">
              <div class="card-heading">
                <div>Accounts Monitored ({{len(accountsMonitored(summary.accounts))}} out of {{len(summary.accounts)}} accounts)</div>
              </div>
              <div class="card-body">
                <PercentageOfAccounts :reported="len(accountsMonitored(summary.accounts))" :total="len(summary.accounts)"/>
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-start" style="margin-bottom: 25px;">
          <div class="col-6">
            <div class="card">
              <div class="card-heading">
                Tools With Failed Cloudformation Stacks
              </div>
              <div class="card-body">
                <ToolsFailedStacks :stacks="summary.failed_stacks"/>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-heading">
                Tools With Failed Code Pipelines
              </div>
              <div class="card-body">
                <ToolsFailedPipeline :pipelines="summary.failed_pipelines"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="active.id === 'bearse2'">
        <BearseFeatures
          :report="tools[active.id]"
          :features="bearseFeatures"
          :templates="tools.bearse2_templates"
          :accounts="summary.accounts"
          :accountsReporting="summary.reported_accounts"/>
      </div>

      <div v-else>
        <div class="row" style="margin-bottom: 15px;">
          <div class="col-4">
            <transition name="fade" appear>
              <div class="card">
                <div class="card-header">
                  <h5>{{active.name}}</h5>
                </div>

                <div v-if="active.id !== 'elmer'" class="card-body">
                  <dl>
                    <dt>Latest Version</dt><dd>{{versions[active.id].latest}}</dd>
                    <dt>Minimum Version</dt><dd>{{versions[active.id].minimum}}</dd>
                    <dt>Source</dt><dd><a :href="versions[active.id].source">{{versions[active.id].source}}</a></dd>
                    <dt>Open Source</dt><dd>{{versions[active.id].opensource}}</dd>
                  </dl>
                </div>
              </div>
            </transition>
          </div>

          <div v-if="active.id === 'ciinabox2'" class="col-4">
            <transition name="fade" appear>
              <div class="card">
                <div class="card-header">
                  <h5>Jenkins Distribution</h5>
                </div>

                <div class="card-body">
                  <dl>
                    <dt>Latest Version</dt><dd>{{versions['jenkinsdistribution'].latest}}</dd>
                    <dt>Minimum Version</dt><dd>{{versions['jenkinsdistribution'].minimum}}</dd>
                    <dt>Source</dt><dd><a :href="versions['jenkinsdistribution'].source">{{versions['jenkinsdistribution'].source}}</a></dd>
                    <dt>Open Source</dt><dd>{{versions['jenkinsdistribution'].opensource}}</dd>
                  </dl>
                </div>
              </div>
            </transition>
          </div>

          <div v-if="active.id === 'ciinabox'" class="col-4">
            <transition name="fade" appear>
              <div class="card">
                <div class="card-header">
                  <h5>Jenkins</h5>
                </div>

                <div class="card-body">
                  <dl>
                    <dt>Latest Version</dt><dd>{{versions.jenkins.latest}}</dd>
                    <dt>Minimum Version</dt><dd>{{versions.jenkins.minimum}}</dd>
                    <dt>Source</dt><dd><a :href="versions.jenkins.source">{{versions.jenkins.source}}</a></dd>
                    <dt>Open Source</dt><dd>{{versions.jenkins.opensource}}</dd>
                  </dl>
                </div>
              </div>
            </transition>
          </div>

          <div v-if="active.id === 'ciinabox'" class="col-4">
            <transition name="fade" appear>
              <div class="card">
                <div class="card-header">
                  <h5>Docker Agent</h5>
                </div>

                <div class="card-body">
                  <dl>
                    <dt>Latest Version</dt><dd>{{versions['ciinaboxdockerslave'].latest}}</dd>
                    <dt>Minimum Version</dt><dd>{{versions['ciinaboxdockerslave'].minimum}}</dd>
                    <dt>Source</dt><dd><a :href="versions['ciinaboxdockerslave'].source">{{versions['ciinaboxdockerslave'].source}}</a></dd>
                    <dt>Open Source</dt><dd>{{versions['ciinaboxdockerslave'].opensource}}</dd>
                  </dl>
                </div>
              </div>
            </transition>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <transition name="fade" appear>
              <vue-good-table
                :columns="active.table"
                :rows="tools[active.id]"
                :search-options="{
                  enabled: true,
                  skipDiacritics: true,
                  placeholder: 'filter',
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: 20,
                }"
                styleClass="vgt-table condensed">
              </vue-good-table>
            </transition>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'
import ToolsMigrated from '@/components/charts/ToolsMigrated'
import ToolsFailedPipeline from '@/components/charts/ToolsFailedPipeline'
import ToolsFailedStacks from '@/components/charts/ToolsFailedStacks'
import ToolsBearseFeatures from '@/components/charts/ToolsBearseFeatures'
import ToolsOutdatedVersion from '@/components/charts/ToolsOutdatedVersion'
import PercentageOfAccounts from '@/components/charts/PercentageOfAccounts'

import BearseFeatures from '@/components/Tools/BearseFeatures'

export default {
  name: 'base2tools',
  props: [
    'id'
  ],
  components: {
    VueLoading,
    ToolsMigrated,
    ToolsFailedPipeline,
    ToolsFailedStacks,
    ToolsBearseFeatures,
    ToolsOutdatedVersion,
    PercentageOfAccounts,
    BearseFeatures
  },
  data () {
    return {
      tools: {},
      summary: {},
      versions: {},
      bearseFeatures: {},
      active: {
        id: 'summary',
        table: []
      },
      activeRow: {
        id: null
      },
      centred: true,
      loading: false,
      menu: [
        {
          name: 'summary',
          id: 'summary',
          table: []
        },
        {
          name: 'elmer',
          id: 'elmer',
          table: [
            {
              label: 'Contract',
              field: 'contract'
            },
            {
              label: 'Account Name',
              field: 'account_name'
            },
            {
              label: 'Account Id',
              field: 'account_id'
            },
            {
              label: 'State',
              field: 'state'
            },
            {
              label: 'Region',
              field: 'region'
            },
            {
              label: 'Stack Updated',
              field: 'last_update',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            },
            {
              label: 'Reported',
              field: 'timestamp',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            }
          ]
        },
        {
          name: 'bearse',
          id: 'bearse',
          table: [
            {
              label: 'Contract',
              field: 'contract'
            },
            {
              label: 'Account Name',
              field: 'account_name'
            },
            {
              label: 'Account',
              field: 'account_id'
            },
            {
              label: 'State',
              field: 'state'
            },
            {
              label: 'Version',
              field: 'version'
            },
            {
              label: 'Region',
              field: 'region'
            },
            {
              label: 'Features',
              field: this.getBearseFeatures,
              type: 'percentage'
            },
            {
              label: 'Stack Updated',
              field: 'last_update',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            },
            {
              label: 'Reported',
              field: 'timestamp',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            }
          ]
        },
        {
          name: 'bearse v2',
          id: 'bearse2',
          table: []
        },
        {
          name: 'ciinabox',
          id: 'ciinabox',
          table: [
            {
              label: 'Contract',
              field: 'contract'
            },
            {
              label: 'Account Name',
              field: 'account_name'
            },
            {
              label: 'Account Id',
              field: 'account_id'
            },
            {
              label: 'Ciinabox Name',
              field: 'name'
            },
            {
              label: 'Version',
              field: 'version'
            },
            {
              label: 'Jenkins Version',
              field: 'jenkins_image'
            },
            {
              label: 'Jenkins Agent Version',
              field: 'docker_agent_image'
            },
            {
              label: 'State',
              field: 'state'
            },
            {
              label: 'Region',
              field: 'region'
            },
            {
              label: 'Reported',
              field: 'timestamp',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            }
          ]
        },
        {
          name: 'ciinabox v2',
          id: 'ciinabox2',
          table: [
            {
              label: 'Contract',
              field: 'contract'
            },
            {
              label: 'Account Name',
              field: 'account_name'
            },
            {
              label: 'Account Id',
              field: 'account_id'
            },
            {
              label: 'Ciinabox Name',
              field: 'name'
            },
            {
              label: 'Ci2 Version',
              field: 'version'
            },
            {
              label: 'Jenkins Version',
              field: 'jenkins_version'
            },
            {
              label: 'State',
              field: 'state'
            },
            {
              label: 'Region',
              field: 'region'
            },
            {
              label: 'Ci2 Pipeline State',
              field: this.ciinaboxPipelineState
            },
            {
              label: 'Jcasc Pipeline State',
              field: this.jcascPipelineState
            },
            {
              label: 'Stack Updated',
              field: 'last_update',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            },
            {
              label: 'Reported',
              field: 'timestamp',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            }
          ]
        },
        {
          name: 'guardian',
          id: 'guardian',
          table: [
            {
              label: 'Contract',
              field: 'contract'
            },
            {
              label: 'Account Name',
              field: 'account_name'
            },
            {
              label: 'Account Id',
              field: 'account_id'
            },
            {
              label: 'Region',
              field: 'region'
            },
            {
              label: 'Version',
              field: 'version'
            },
            {
              label: 'State',
              field: 'state'
            },
            {
              label: 'Latest Commit Deployed',
              field: this.guardianCommitsInSync
            },
            {
              label: 'Pipeline State',
              field: this.guardianPipelineState
            },
            {
              label: 'Stack Updated',
              field: 'last_update',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            },
            {
              label: 'Reported',
              field: 'timestamp',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            }
          ]
        },
        {
          name: 'cfn-monitor',
          id: 'cfnmonitor',
          table: [
            {
              label: 'Contract',
              field: 'contract'
            },
            {
              label: 'Account Name',
              field: 'account_name'
            },
            {
              label: 'Account Id',
              field: 'account_id'
            },
            {
              label: 'Version',
              field: 'version'
            },
            {
              label: 'Monitored Stack',
              field: 'monitored_stack'
            },
            {
              label: 'Disabled',
              field: 'monitoring_disabled'
            },
            {
              label: 'Render Date',
              field: 'render_date'
            },
            {
              label: 'State',
              field: 'state'
            },
            {
              label: 'Region',
              field: 'region'
            },
            {
              label: 'Stack Updated',
              field: 'last_update',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            },
            {
              label: 'Reported',
              field: 'timestamp',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            }
          ]
        },
        {
          name: 'cfn-vpn',
          id: 'cfnvpn',
          table: [
            {
              label: 'Contract',
              field: 'contract'
            },
            {
              label: 'Account Name',
              field: 'account_name'
            },
            {
              label: 'Account Id',
              field: 'account_id'
            },
            {
              label: 'Region',
              field: 'region'
            },
            {
              label: 'Version',
              field: 'version'
            },
            {
              label: 'State',
              field: 'state'
            },
            {
              label: 'Stack Updated',
              field: 'last_update',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            },
            {
              label: 'Reported',
              field: 'timestamp',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            }
          ]
        },
        {
          name: 'cfn-opvn',
          id: 'cfnopvn',
          table: [
            {
              label: 'Contract',
              field: 'contract'
            },
            {
              label: 'Account Name',
              field: 'account_name'
            },
            {
              label: 'Account Id',
              field: 'account_id'
            },
            {
              label: 'Region',
              field: 'region'
            },
            {
              label: 'Version',
              field: 'version'
            },
            {
              label: 'AMI',
              field: 'ami'
            },
            {
              label: 'State',
              field: 'state'
            },
            {
              label: 'Stack Updated',
              field: 'last_update',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            },
            {
              label: 'Reported',
              field: 'timestamp',
              type: 'date',
              dateInputFormat: 't',
              dateOutputFormat: 'MMM do yyyy KK:mm a'
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'activeType'
    ])
  },
  methods: {
    getData: function () {
      this.loading = true
      HTTP.get(`/base2tools/${this.activeType}/${this.id}`)
        .then((response) => {
          this.tools = response.data.tools
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get base2tools report : ${error.message}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getSummary: function () {
      HTTP.get(`/base2tools/summary/${this.activeType}/${this.id}`)
        .then((response) => {
          if (Object.keys(response.data).length === 0) {
            this.summary = {
              accounts: [],
              reported_accounts: []
            }
          } else {
            this.summary = response.data
          }
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get base2tools summary : ${error.message}`
          })
        })
    },
    getVersions: function () {
      HTTP.get('/base2tools/versions')
        .then((response) => {
          let toolVersions = {}
          // remove hyphens from tool names in versions API response to match IDs defined in this file as the "versions" and "tools" APIs are not consistent with each other
          for (const [key, value] of Object.entries(response.data.tools)) {
            toolVersions[key.replace(new RegExp('-', 'gi'), '')] = value
          }
          this.versions = toolVersions
          this.bearseFeatures = response.data.bearse_features
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get base2tools versions : ${error.message}`
          })
        })
    },
    updateTool: function (tool) {
      if (this.centred === true) {
        this.centred = false
      }
      this.tool = this[`${tool.toLowerCase()}`]
    },
    checkActive: function (activeToolId) {
      return activeToolId === this.active.id
    },
    getToolItem: function (toolId) {
      var tool = this.menu.find(item => {
        return item.id === toolId
      })
      return tool
    },
    getBearseFeatures: function (rowObj) {
      let counter = 0
      for (const feature of rowObj.features) {
        if (Object.values(feature)[0] === 'true') counter += 1
      }
      return counter / rowObj.features.length
    },
    guardianCommitsInSync: function (rowObj) {
      return rowObj.deployed_commit === rowObj.latest_commit
    },
    guardianPipelineState: function (rowObj) {
      for (const step in rowObj.pipeline) {
        if (rowObj.pipeline[step].state !== 'Succeeded') {
          return rowObj.pipeline[step].state
        }
      }
      return 'OK'
    },
    ciinaboxPipelineState: function (rowObj) {
      for (const step in rowObj.ciinabox_pipeline) {
        if (rowObj.ciinabox_pipeline[step].state !== 'Succeeded') {
          return rowObj.ciinabox_pipeline[step].state
        }
      }
      return 'OK'
    },
    jcascPipelineState: function (rowObj) {
      for (const step in rowObj.jcasc_pipeline) {
        if (rowObj.jcasc_pipeline[step].state !== 'Succeeded') {
          return rowObj.jcasc_pipeline[step].state
        }
      }
      return 'OK'
    },
    len: function (obj) {
      return (typeof obj !== 'undefined') ? obj.length : 0
    },
    accountsMonitored: function (accounts) {
      return accounts.filter(account => account.accounts_monitored === true).map(account => account.account_id)
    }
  },
  created: function () {
    this.getData()
    this.getSummary()
    this.getVersions()
  },
  watch: {
    active: function () {
      this.activeRow = {
        id: null
      }
    },
    id: function () {
      this.tools = {}
      this.summary = {}
      this.active = {
        id: 'summary',
        table: []
      }
      this.activeRow = {
        id: null
      }
      this.getData()
      this.getSummary()
    }
  }
}
</script>

<style scoped>
.sub-nav {
  margin-bottom: 15px;
  box-shadow: 0 2px 17px -5px rgba(0,0,0,0.2);
}
.card {
  background: #ffffff;
  border: none;
  box-shadow: 0 2px 17px -5px rgba(0,0,0,0.2);
}

.card-header {
  background: #ffffff;
  border: none;
}

.card-heading {
  padding-left: 1.25rem;
  padding-top: 1rem;
}

.card-bod {
  padding: 0.75rem;
}
.block {
  display: inline;
  text-align: center;
  vertical-align: middle;
}
.circle {
  border: 15px solid #06d6a0;
  border-radius: 50%;
  color: rgba(0, 0, 0, 0.75);
  height: 200px;
  font-weight: bold;
  width: 200px;
  display: table;
  margin: 20px auto;
}
.circle h1 {
  vertical-align: middle;
  display: table-cell;
  font-size: 4rem;
}

ul.nav a {
  color: rgba(0, 0, 0, 0.5);
}

ul.nav a:hover {
  cursor: pointer;
  color: rgba(0, 0, 0, 1);
}

.active {
  color: rgba(0, 0, 0, 0.8) !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 200ms ease-in-out;
}
.fade-enter-to {
  opacity: 1;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

dl {
  display: grid;
  grid-template-columns: max-content auto;
}

dt {
  grid-column-start: 1;
  margin-right: 10px;
}

dd {
  grid-column-start: 2;
}
</style>



// WEBPACK FOOTER //
// src/views/Tools.vue